<template>
  <div class="d-flex flex-column flex-lg-row flex-column-fluid stepper stepper-pills stepper-column  bg-white"
    id="kt_create_account_stepper">
    <div class="d-none  d-md-none d-xl-flex flex-column flex-lg-row-auto w-xl-600px positon-xl-relative" style="background-color: rgb(239, 251, 240); box-shadow: rgba(0, 0, 0, 0.15) 3px 0px 17px; height: 100vh; ">
      <div class="d-flex flex-column position-xl-fixed top-0 bottom-0 w-xl-500px scroll-y">
        <div class="d-flex flex-row-fluid flex-column flex-center p-10 pt-lg-20">
          <a href="#" class="mb-10 mb-lg-20">
            <img alt="Logo" src="/assets/media/kshop_mini.png" class="h-75px" />
          </a>
          <div class="stepper-nav">
            <img alt="Logo" src="/assets/media/frame_deleting.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="container py-8 py-lg-12 flex-grow-1 d-flex justify-content-center align-items-center">
      <div class="w-100 max-w-700px">
        
        <!-- Success State View -->
        <transition name="fade-slide" mode="out-in">
          <div v-if="submittedSuccess" class="card card-custom shadow-lg border-0 rounded-4 overflow-hidden text-center p-8 p-lg-12">
            <div class="mx-auto mb-6 d-flex align-items-center justify-content-center rounded-circle icon-box">
              <img alt="Logo" src="/assets/media/kshop_mini.png" class="h-40px" />
            </div>
            
            <h2 class="fs-2x fw-bolder text-gray-900 mb-4">{{ $t('account_deletion.success_title') }}</h2>
            
            <p class="fs-6 text-gray-600 mb-6 leading-relaxed max-w-500px mx-auto">
              {{ $t('account_deletion.success_subtitle') }}
              <strong class="text-dark">{{ form.email ? 'e-mail' : 'SMS' }}</strong> ({{ form.email || (form.phone_code + ' ' + form.phone) }}).
              {{ $t('account_deletion.success_subtitle_end') }}
            </p>

            <!-- Verification Code Input Box -->
            <div class="bg-light-primary rounded-3 p-6 mb-8 border border-primary-subtle text-start">
              <div class="d-flex align-items-center mb-3">
                <i class="ki-outline ki-shield-tick fs-3 text-primary me-2"></i>
                <h5 class="fs-6 fw-bold text-dark m-0">{{ $t('account_deletion.verification_title') }}</h5>
              </div>
              <p class="fs-7 text-gray-600 mb-4">{{ $t('account_deletion.verification_desc') }}</p>

              <div class="d-flex justify-content-center gap-2 mb-4">
                <input 
                  v-for="(digit, index) in verificationCode" 
                  :key="index"
                  :id="`code-input-${index}`"
                  type="text" 
                  maxlength="1"
                  v-model="verificationCode[index]"
                  @input="onCodeInput(index, $event)"
                  @keydown.delete="onCodeKeydown(index, $event)"
                  class="form-control form-control-solid text-center fw-bolder fs-3 shadow-none p-0 code-digit-input"
                />
              </div>

              <div v-if="codeError" class="text-danger fs-7 text-center mb-3">
                <i class="ki-outline ki-information-2 me-1"></i> {{ codeError }}
              </div>

              <button 
                type="button" 
                @click="confirmAccountDeletion" 
                :disabled="isVerifying || !isCodeComplete"
                class="btn btn-danger w-100 fw-bolder py-3 d-flex justify-content-center align-items-center gap-2 rounded-3"
              >
                <span v-if="isVerifying" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                <span>{{ isVerifying ? $t('account_deletion.btn_verifying') : 'Confirmer la demande' }}</span>
              </button>
            </div>

            <div class="d-flex justify-content-center gap-4">
              <button @click="resendCode" class="btn btn-light fw-bold px-6" :disabled="resendTimer > 0 || isResending">
                <span v-if="isResending" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                <span v-if="resendTimer > 0">{{ $t('account_deletion.btn_resend_code_timer', { time: resendTimer }) }}</span>
                <span v-else>{{ $t('account_deletion.btn_resend_code') }}</span>
              </button>
            </div>
          </div>

          <!-- Main Deletion Form -->
          <div v-else class="card card-custom shadow-lg border-0 rounded-4 overflow-hidden">
            <!-- Header Section -->
            <div class="card-header-gradient p-8 p-lg-10 border-bottom">
              <div class="d-flex align-items-center justify-content-center mx-auto mb-6 w-100">
                  <img alt="Logo" src="/assets/media/kshop_mini.png" class="h-60px" />
              </div>
              <div class="d-flex align-items-center gap-3 mb-3">
                
                <div class="d-flex align-items-center justify-content-center mx-auto mb-3">
                  <h1 class="fs-2x fw-bolder text-gray-900 m-0">{{ $t('account_deletion.title') }}</h1>
                </div>
              </div>
              <p class="fs-6 text-gray-600 m-0 leading-relaxed">
                {{ $t('account_deletion.subtitle') }}
              </p>
            </div>

            <!-- Form Body -->
            <div class="card-body p-8 p-lg-10">
              <form @submit.prevent="submitDeletionRequest" novalidate id="account-deletion-form">
                
                <!-- Notice Alert Box -->
                <div class="alert alert-dismissible bg-light-warning border border-warning-subtle d-flex align-items-start p-5 mb-8 rounded-3">
                  <i class="ki-outline ki-information-4 fs-2x text-warning me-4 mt-1"></i>
                  <div class="d-flex flex-column">                    
                    <h5 class="fs-6 fw-bolder text-gray-900 mb-1">
                      <i class="bi bi-exclamation-triangle-fill text-warning me-2"></i>
                      {{ $t('account_deletion.important_info_title') }}
                    </h5>
                    <span class="fs-7 text-gray-700 mb-2">
                      {{ $t('account_deletion.important_info_desc') }}
                    </span>

                    <span class="mb-2 fs-7 fw-bolder">
                        {{ $t('account_deletion.afterValidation') }}
                    </span>

                      <ul class="mb-3 fs-7 text-gray-700" style="list-style: disc;">
                          <li>{{ $t('account_deletion.accountDeleted') }}</li>
                          <li>{{ $t('account_deletion.personalDataDeleted') }}</li>
                          <li>{{ $t('account_deletion.legalRetention') }}</li>
                          <li>{{ $t('account_deletion.irreversible') }}</li>
                      </ul>

                      <p class="mb-0 fs-7 fw-bolder">
                          {{ $t('account_deletion.processingTime') }}
                      </p>
                  </div>
                </div>

                <!-- Form Fields -->
                <div class="row g-6 mb-6">
                  
                  <!-- Nom de la société (society_name) -->
                  <div class="col-12">
                    <label for="society_name" class="form-label fw-bolder fs-6 text-gray-800 d-flex justify-content-between">
                      <span>{{ $t('account_deletion.company_name') }}</span>
                      <span class="text-muted fw-normal fs-7">({{ $t('account_deletion.optional_recommanded') }})</span>
                    </label>
                    <div class="input-group-custom">
                      <i class="ki-outline ki-bank input-icon fs-4 text-gray-500"></i>
                      <input 
                        id="society_name"
                        v-model="form.society_name" 
                        type="text" 
                        class="form-control form-control-solid ps-12 py-3 fs-6 rounded-3" 
                        placeholder="Ex: ACME Corporation"
                        :disabled="isSubmitting"
                      />
                    </div>
                  </div>


                  <div class="row col-12 mt-6">
                  <!-- Phone & Phone Code (phone_code & phone) -->
                    <div class="col-12 col-md-6 mb-6 mb-md-0">
                      <label for="phone" class="form-label fw-bolder fs-6 text-gray-800">
                        {{ $t('account_deletion.phone') }}
                        <span v-if="phoneRequired" class="text-danger">*</span>
                        <span v-else class="text-muted fw-normal fs-7 ms-1">({{ $t('account_deletion.optional_if_email') }})</span>
                      </label>

                      <div class="row g-3">
                        <div class="tel-input-wrapper" :class="{'border-danger bg-light-danger': errors.phone}">
                          <vue-tel-input
                            :inputOptions="options"
                            @country-changed="inputCountryChanged"
                            :autoDefaultCountry="true"
                            id="phone"
                            name="phone"
                            v-model="rawPhone"
                          ></vue-tel-input>
                        </div>
                      </div>
                      <!-- Error Message Phone -->
                      <div v-if="errors.phone" class="invalid-feedback-custom text-danger fs-7 mt-2 d-flex align-items-center gap-1">
                        <i class="ki-outline ki-information-2 fs-6 text-danger"></i>
                        <span>{{ errors.phone }}</span>
                      </div>
                      <div v-if="errors.phone_code" class="invalid-feedback-custom text-danger fs-7 mt-2 d-flex align-items-center gap-1">
                        <i class="ki-outline ki-information-2 fs-6 text-danger"></i>
                        <span>{{ errors.phone_code }}</span>
                      </div>
                    </div>

                    <!-- Email Address -->
                    <div class="col-12 col-md-6">
                      <label for="email" class="form-label fw-bolder fs-6 text-gray-800">
                        {{ $t('account_deletion.email') }}
                        <span v-if="emailRequired" class="text-danger">*</span>
                        <span v-else class="text-muted fw-normal fs-7 ms-1">({{ $t('account_deletion.optional_if_phone') }})</span>
                      </label>
                      <div class="input-group-custom">
                        <i class="ki-outline ki-sms input-icon fs-4 text-gray-500"></i>
                        <input 
                          id="email"
                          v-model="form.email" 
                          @input="clearFieldError('email')"
                          type="email" 
                          class="form-control form-control-solid ps-12 py-3 fs-6 rounded-3"
                          :class="{'is-invalid': errors.email}"
                          placeholder="nom@exemple.com"
                          autocomplete="email"
                          :disabled="isSubmitting"
                        />
                      </div>
                      <!-- Error Message Email -->
                      <div v-if="errors.email" class="invalid-feedback-custom text-danger fs-7 mt-2 d-flex align-items-center gap-1">
                        <i class="ki-outline ki-information-2 fs-6 text-danger"></i>
                        <span>{{ errors.email }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- Motif de la suppression (reason) -->
                  <div class="col-12">
                    <label for="reason" class="form-label fw-bolder fs-6 text-gray-800 d-flex justify-content-between">
                      <span>{{ $t('account_deletion.reason') }}</span>
                      <span class="text-muted fw-normal fs-7">({{ $t('account_deletion.optional') }})</span>
                    </label>
                    <textarea 
                      id="reason"
                      v-model="form.reason" 
                      rows="3"
                      class="form-control form-control-solid p-4 fs-6 rounded-3"
                      :placeholder="$t('account_deletion.reason_placeholder')"
                      :disabled="isSubmitting"
                    ></textarea>
                  </div>

                  <!-- Mandatory Checkbox (confirmation) -->
                  <div class="col-12 mt-4">
                    <div class="form-check form-check-custom form-check-solid align-items-start p-4 rounded-3 bg-light-subtle border" :class="{'border-danger bg-light-danger': errors.confirmation}">
                      <input 
                        id="confirmation"
                        v-model="form.confirmation" 
                        @change="clearFieldError('confirmation')"
                        type="checkbox" 
                        class="form-check-input mt-1 me-3 flex-shrink-0 cursor-pointer"
                        :class="{'is-invalid': errors.confirmation}"
                        :disabled="isSubmitting"
                      />
                      <label for="confirmation" class="form-check-label fs-7 text-gray-700 leading-relaxed cursor-pointer user-select-none">
                        {{ $t('account_deletion.checkbox_legal') }}
                      </label>
                    </div>
                    <!-- Error Message Confirmation -->
                    <div v-if="errors.confirmation" class="invalid-feedback-custom text-danger fs-7 mt-2 d-flex align-items-center gap-1 ms-1">
                      <i class="ki-outline ki-information-2 fs-6 text-danger"></i>
                      <span>{{ errors.confirmation }}</span>
                    </div>
                  </div>

                </div>

                <!-- Submit Button Area -->
                <div class="d-flex flex-column flex-sm-row align-items-center gap-4 pt-6 border-top">
                  <button 
                    type="submit" 
                    id="btn_submit_deletion"
                    class="btn btn-danger btn-lg w-100 fw-bolder px-8 py-3 d-flex justify-content-center align-items-center gap-2 rounded-3 shadow-sm transition-all"
                    :disabled="isSubmitting || !isFormValid"
                  >
                    <!-- Spinner Component -->
                    <span v-if="isSubmitting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <i v-else class="ki-outline ki-trash fs-4"></i>
                    <span>{{ isSubmitting ? $t('account_deletion.btn_submitting') : $t('account_deletion.btn_submit') }}</span>
                  </button>
                </div>

              </form>
            </div>
          </div>
        </transition>

      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onUnmounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import axiosDefault from '@/services/defaultAxios'
import { VueTelInput } from 'vue-tel-input'
import 'vue-tel-input/vue-tel-input.css'

const landingPageUrl = import.meta.env.VITE_LANDING_PAGE_URL || '/'

const router = useRouter()
const { t } = useI18n()

const emailRequired = computed(() => !form.phone || String(form.phone).trim() === '')
const phoneRequired = computed(() => !form.email || String(form.email).trim() === '')

const isFormValid = computed(() => {
  const hasEmail = form.email && String(form.email).trim() !== ''
  const cleanPhone = form.phone ? String(form.phone).replace(/[\s\-()]/g, '') : ''
  const hasPhone = cleanPhone.length > 5
  return (hasEmail || hasPhone) && form.confirmation
})

const form = reactive({
  society_name: '',
  email: '',
  phone_code: '',
  phone: '',
  reason: '',
  confirmation: false
})

const rawPhone = ref('')

// UI States
const isSubmitting = ref(false)
const submittedSuccess = ref(false)
const errors = reactive({
  email: '',
  phone_code: '',
  phone: '',
  confirmation: ''
})

// Verification Code State
const verificationCode = reactive(['', '', '', '', '', ''])
const isVerifying = ref(false)
const codeError = ref('')
const resendTimer = ref(60)
const isResending = ref(false)
let timerInterval = null

const isCodeComplete = computed(() => {
  return verificationCode.every(digit => digit.length === 1 && /^\d$/.test(digit))
})

// Countries list from API
const getCountries = ref([])

// Default fallback list
const defaultCountries = [
  { id: 1, name: 'France', phone_code: '33' },
  { id: 2, name: 'Bénin', phone_code: '229' },
  { id: 3, name: 'Côte d\'Ivoire', phone_code: '225' },
  { id: 4, name: 'Sénégal', phone_code: '221' },
  { id: 5, name: 'Togo', phone_code: '228' },
  { id: 6, name: 'Cameroun', phone_code: '237' },
  { id: 7, name: 'Burkina Faso', phone_code: '226' },
  { id: 8, name: 'Mali', phone_code: '223' },
  { id: 9, name: 'Guinée', phone_code: '224' },
  { id: 10, name: 'Nigéria', phone_code: '234' },
  { id: 11, name: 'Maroc', phone_code: '212' },
  { id: 12, name: 'Algérie', phone_code: '213' },
  { id: 13, name: 'Tunisie', phone_code: '216' },
  { id: 14, name: 'Congo', phone_code: '242' },
  { id: 15, name: 'RDC', phone_code: '243' },
  { id: 16, name: 'Gabon', phone_code: '241' },
  { id: 17, name: 'Canada / USA', phone_code: '1' },
  { id: 18, name: 'Royaume-Uni', phone_code: '44' },
  { id: 19, name: 'Allemagne', phone_code: '49' },
  { id: 20, name: 'Belgique', phone_code: '32' },
  { id: 21, name: 'Suisse', phone_code: '41' },
]

// Exactly like loadCountries() in CreateAccount.vue
async function loadCountries() {
  try {
    const response = await axiosDefault.get('get/countries')
    const countriesData = response.data?.countries || response.data || []
    if (Array.isArray(countriesData) && countriesData.length > 0) {
      getCountries.value = countriesData
    } else {
      getCountries.value = defaultCountries
    }
  } catch (err) {
    console.warn('Could not load countries from get/countries, using default list:', err)
    getCountries.value = defaultCountries
  }
}

onMounted(() => {
  loadCountries()
})

onUnmounted(() => {
  if (timerInterval) clearInterval(timerInterval)
})

function clearFieldError(field) {
  errors[field] = ''
  if (field === 'email' || field === 'phone') {
    if (form.email || form.phone) {
      if (errors.email === t('account_deletion.error_email_or_phone')) {
        errors.email = ''
      }
      if (errors.phone === t('account_deletion.error_email_or_phone')) {
        errors.phone = ''
      }
    }
  }
}

function validateEmail(email) {
  const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return re.test(String(email).toLowerCase())
}

function validateForm() {
  errors.email = ''
  errors.phone_code = ''
  errors.phone = ''
  errors.confirmation = ''

  let isValid = true

  const hasEmail = form.email && String(form.email).trim() !== ''
  const hasPhone = form.phone && String(form.phone).trim() !== ''

  if (!hasEmail && !hasPhone) {
    errors.email = t('account_deletion.error_email_or_phone')
    errors.phone = t('account_deletion.error_email_or_phone')
    isValid = false
  }

  if (hasEmail && !validateEmail(String(form.email).trim())) {
    errors.email = t('account_deletion.error_email_invalid')
    isValid = false
  }

  if (hasPhone) {
    if (!form.phone_code || String(form.phone_code).trim() === '') {
      errors.phone_code = t('account_deletion.error_country_code_required')
      isValid = false
    }

    const cleanPhone = String(form.phone).replace(/[\s\-()]/g, '')
    if (!/^\d{6,15}$/.test(cleanPhone)) {
      errors.phone = t('account_deletion.error_phone_invalid')
      isValid = false
    }
  }

  if (!form.confirmation) {
    errors.confirmation = t('account_deletion.error_checkbox_required')
    isValid = false
  }

  return isValid
}

const options = {
  placeholder: t('account_deletion.phone'),
  showDialCode: true,
  nationalMode: true,
  inputClasses: 'border-0 bg-transparent'
}

async function submitDeletionRequest() {
  if (!validateForm()) {
    const firstInvalid = document.querySelector('.is-invalid')
    if (firstInvalid) {
      firstInvalid.focus()
    }
    return
  }

  isSubmitting.value = true

  // Payload format matching requested schema:
  // society_name, email, phone, phone_code, reason, confirmation
  const payload = {
    society_name: form.society_name,
    email: form.email || null,
    phone: form.phone || null,
    phone_code: form.phone ? form.phone_code : null,
    reason: form.reason,
    confirmation: form.confirmation
  }

  try {
    // Calling central API without tenant via axiosDefault instance
    const response = await axiosDefault.post('send/account-deletion/request', payload)

    if (window.toastr) {
      window.toastr.success(response?.data?.message || t('account_deletion.success_message'))
    }

    submittedSuccess.value = true
    startResendTimer()
  } catch (err) {
    const serverMessage = err.response?.data?.message || err.response?.data?.error
    if (window.toastr) {
      window.toastr.error(serverMessage || 'Une erreur est survenue lors du traitement de votre demande.')
    }
  } finally {
    isSubmitting.value = false
  }
}

watch(rawPhone, (newVal) => {
  clearFieldError('phone')

  if (!newVal) {
    form.phone = ''
    return
  }

  let cleaned = String(newVal).replace(/[^\d]/g, '')

  // Retire l'indicatif pays s'il est dupliqué en tête du numéro
  const dialDigits = form.phone_code ? form.phone_code.replace(/[^\d]/g, '') : ''
  if (dialDigits && cleaned.startsWith(dialDigits)) {
    cleaned = cleaned.slice(dialDigits.length)
  }

  form.phone = cleaned
})
function inputCountryChanged(country) {
  if (country?.dialCode) {
    form.phone_code = `+${country.dialCode}`
    
    if (rawPhone.value) {
      let cleaned = String(rawPhone.value).replace(/[^\d]/g, '')
      const dialDigits = String(country.dialCode)
      if (cleaned.startsWith(dialDigits)) {
        cleaned = cleaned.slice(dialDigits.length)
      }
      form.phone = cleaned
    }
  }
}

function onCodeInput(index, event) {
  const val = event.target.value
  codeError.value = ''
  if (val && index < 5) {
    const nextInput = document.getElementById(`code-input-${index + 1}`)
    if (nextInput) nextInput.focus()
  }
}

function onCodeKeydown(index, event) {
  if (!verificationCode[index] && index > 0) {
    const prevInput = document.getElementById(`code-input-${index - 1}`)
    if (prevInput) prevInput.focus()
  }
}

async function confirmAccountDeletion() {
  if (!isCodeComplete.value) return

  isVerifying.value = true
  codeError.value = ''

  const code = verificationCode.join('')

  try {
    const response = await axiosDefault.post('send/account-deletion/confirm', {
      email: form.email,
      phone: form.phone,
      phone_code: form.phone_code,
      code: code
    })

    if (window.toastr) {
      window.toastr.success(response?.data?.message || t('account_deletion.confirmed_message'))
    }
    window.location.href = landingPageUrl
    
  } catch (err) {
    const serverMessage = err.response?.data?.message || err.response?.data?.error
    
    codeError.value = serverMessage || t('account_deletion.error_code_invalid')
    
  } finally {
    isVerifying.value = false
  }
}

function startResendTimer() {
  resendTimer.value = 60
  if (timerInterval) clearInterval(timerInterval)
  timerInterval = setInterval(() => {
    if (resendTimer.value > 0) {
      resendTimer.value--
    } else {
      clearInterval(timerInterval)
    }
  }, 1000)
}

async function resendCode() {
  if (resendTimer.value > 0 || isResending.value) return
  
  isResending.value = true
  const payload = {
    society_name: form.society_name,
    email: form.email || null,
    phone: form.phone || null,
    phone_code: form.phone ? form.phone_code : null,
    reason: form.reason,
    confirmation: form.confirmation,
    is_resend: true
  }
  
  try {
    const response = await axiosDefault.post('send/account-deletion/request', payload)
    if (window.toastr) {
      window.toastr.success(response?.data?.message || "Le code a été renvoyé avec succès.")
    }
    verificationCode.fill('')
    startResendTimer()
  } catch (err) {
    const serverMessage = err.response?.data?.message || err.response?.data?.error
    if (window.toastr) {
      window.toastr.error(serverMessage || "Erreur lors du renvoi du code.")
    }
  } finally {
    isResending.value = false
  }
}

function resetForm() {
  form.society_name = ''
  form.email = ''
  form.phone_code = '+229'
  form.phone = ''
  form.reason = ''
  form.confirmation = false
  
  errors.email = ''
  errors.phone_code = ''
  errors.phone = ''
  errors.confirmation = ''
  
  verificationCode.fill('')
  submittedSuccess.value = false
}
</script>

<style scoped>
/* Gradient Background */
.bg-gradient-light {
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%);
}

/* Card Styling */
.card-custom {
  background: #ffffff;
  border-radius: 1.25rem !important;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08) !important;
}

.card-header-gradient {
  background: linear-gradient(180deg, #ffffff 0%, #f9fafb 100%);
}

.max-w-700px {
  max-width: 700px;
}

.max-w-500px {
  max-width: 500px;
}

/* Icons and Badges */
.badge-icon-danger {
  width: 54px;
  height: 54px;
  border-radius: 14px;
  background-color: #ffeef0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.icon-box {
  width: 90px;
  height: 90px;
}

/* Input Styling */
.input-group-custom {
  position: relative;
}

.input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 4;
  pointer-events: none;
}

.form-control-solid,
.form-select-solid {
  background-color: #f4f6f9 !important;
  border: 1.5px solid transparent !important;
  color: #181c32;
  transition: all 0.2s ease-in-out;
}

.form-control-solid:focus,
.form-select-solid:focus {
  background-color: #ffffff !important;
  border-color: #0072ce !important;
  box-shadow: 0 0 0 4px rgba(0, 114, 206, 0.12) !important;
}

.form-control.is-invalid,
.form-select.is-invalid,
.form-check-input.is-invalid {
  border-color: #f1416c !important;
  background-color: #fff5f8 !important;
}

.form-control.is-invalid:focus {
  box-shadow: 0 0 0 4px rgba(241, 65, 108, 0.15) !important;
}

/* Code Digit Input */
.code-digit-input {
  width: 48px;
  height: 56px;
  border-radius: 10px;
  font-size: 1.5rem;
  border: 2px solid #e4e6ef !important;
}

.code-digit-input:focus {
  border-color: #0072ce !important;
  background-color: #fff !important;
}

/* Button & Animations */
.transition-all {
  transition: all 0.25s ease-in-out;
}

.btn-danger {
  background-color: #d9214e;
  border-color: #d9214e;
}

.btn-danger:hover:not(:disabled) {
  background-color: #b71c42;
  border-color: #b71c42;
  transform: translateY(-1px);
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(15px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-15px);
}

/* scoped */
.tel-input-wrapper {
  background-color: #f4f6f9;
  border: 1.5px solid transparent;
  border-radius: 0.475rem;
  min-height: 36px;
  transition: all 0.2s ease-in-out;
}

.tel-input-wrapper:focus-within {
  background-color: #ffffff;
  border-color: #0072ce;
  box-shadow: 0 0 0 4px rgba(0, 114, 206, 0.12);
}

/* :deep() nécessaire pour styler l'intérieur du composant tiers */
.tel-input-wrapper :deep(.vti__input) {
  background-color: transparent !important;
  border: none !important;
  height: 100%;
  padding: 0.65rem 1rem;
}

.tel-input-wrapper :deep(.vue-tel-input) {
  border: none !important;
  background: transparent !important;
}

</style>
